export const IS_TEST = process.env.NODE_ENV === 'test';
export const IS_SSR = typeof window === 'undefined';
